import { consent } from '@/lib/constants';
import { AnimatedFormWrapper } from './wrapper';
import FormWrapper from '@/components/pages/forms/contact/form-wrapper';
import Badge from '@/components/pages/badge';
import { Watch } from '@/components/pages/icons';
import { AnimatedFormProps } from './type';

export function AnimatedFormServer({
  hideWrapperButton,
  hideAll,
  appendMessage,
}: AnimatedFormProps) {
  if (hideAll) return null;

  return (
    <AnimatedFormWrapper hideButton={hideWrapperButton}>
      <FormWrapper
        preppendForm={
          <>
            <Badge
              label="Avg. response time less than 5 mins"
              className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-[125%] z-2"
              icon={<Watch className="h-3 w-3 shrink-0" />}
            />
            <h2 className="text-white text-2xl font-bold leading-[130%] tracking-[-0.48px] text-center mb-6 pt-2">
              Get your free case review
            </h2>
          </>
        }
        consent={consent}
        variant="light"
        submitVariation="default"
        appendForm={
          <p className="text-white text-center font-medium text-sm leading-5 tracking-[0.21px] mt-2 relative z-1">
            We&apos;ll review your case immediately
          </p>
        }
        appendMessage={appendMessage}
        className="**:data-alert-success:w-[calc(100%-48px)]"
        fieldsPrefix="anim"
      />
    </AnimatedFormWrapper>
  );
}
